"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeReadNotification = exports.getExpiredNotisList = exports.clusterNotificationTypesByExpiration = void 0;
const constants_1 = require("../constants");
function clusterNotificationTypesByExpiration(prevNotis) {
    const outdatedNotis = [];
    const upToDateNotis = [];
    Object.values(constants_1.NOTIFICATION_TYPES).forEach((type) => {
        const prevNotiByType = prevNotis === null || prevNotis === void 0 ? void 0 : prevNotis[type];
        let needRevalidate = false;
        if (!prevNotiByType) {
            needRevalidate = true;
        }
        const expiration = Number(prevNotiByType === null || prevNotiByType === void 0 ? void 0 : prevNotiByType.expiration);
        if (prevNotiByType && !Number.isFinite(expiration)) {
            needRevalidate = true;
        }
        if (Number.isFinite(expiration) && expiration < Date.now()) {
            needRevalidate = true;
        }
        if (needRevalidate) {
            outdatedNotis.push(type);
        }
        else {
            upToDateNotis.push(type);
        }
    });
    return { outdatedNotis, upToDateNotis };
}
exports.clusterNotificationTypesByExpiration = clusterNotificationTypesByExpiration;
function getExpiredNotisList(prevNotis) {
    const notisToRevalidate = [];
    if (!prevNotis) {
        return ["all"];
    }
    return notisToRevalidate;
}
exports.getExpiredNotisList = getExpiredNotisList;
function normalizeReadNotification(prevNoti, notification) {
    const prevHashList = (prevNoti === null || prevNoti === void 0 ? void 0 : prevNoti.hashList) || [];
    const finalNoti = Object.assign(Object.assign({}, (notification || {})), { notifications: Array.isArray(notification === null || notification === void 0 ? void 0 : notification.notifications)
            ? notification.notifications
            : [] });
    let unreadHashList = [];
    finalNoti.notifications = finalNoti.notifications.map((noti) => {
        const hash = noti.notificationHash;
        if (!prevHashList.includes(hash)) {
            unreadHashList.push(hash);
            return Object.assign(Object.assign({}, noti), { read: false });
        }
        else {
            return Object.assign(Object.assign({}, noti), { read: true });
        }
    });
    return { notification: finalNoti, unreadHashList };
}
exports.normalizeReadNotification = normalizeReadNotification;
//# sourceMappingURL=notifications.js.map